import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaPlus, FaSearch, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit,MdClose } from 'react-icons/md';
import styles from "./avales.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import ModalAval from './avalesModal';



const customStyles = {
    headRow: {
        style: {
            minHeight: "40px",
            backgroundColor: "#046cc2",
            fontSize: "15px",
            color: "white",
        },
    },


};
export default function Avales(props) {
    const { windowSize,setMenuActual } = useAuth();

    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);
    const { estados, municipios, codigos } = useAuth();
    const [genders, setGenders] = useState([]);

    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [textSearch, setTextSearch] = useState("");
    const [textSearchPrev, setTextSearchPrev] = useState("");


    const columns = [
        {
            name: 'ID',
            selector: row => row.backingId,
        },
        {
            name: 'Nombre',
            selector: row => row.backingName,
        },
        {
            name: 'Dirección',
            selector: row => row.colonyName,
        },
        {
            name: 'Número',
            selector: row => row.phoneNumber,
        },
        {
            name: 'CURP',
            selector: row => row.populationRegistrationCode,
        },
        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-primary' onClick={() => { setUserEdit(row); setShowModal(true); }}><MdEdit /></button>&nbsp;
                        <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.backingName, row.backingId)}><MdDelete /></button>
                    </div>
                )
            },
        }
    ];

    const handleDelete = (userName, userId) => {
        Swal.fire({
            title: "¿Esta segur@ que desea eliminar el aval \"" + userName + "\"?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {

                api(SERVICE.deteleAval + `?BackingId=${userId}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });

    }

    const handleUpdate = () => {
        let URL = SERVICE.getAvalGrid + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (textSearch != "") {
            URL = URL + `&TextSearch=${textSearch}`;
        }
        setTextSearchPrev(textSearch);
        setTextSearch("");
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if(data && data.data && data.data.paginationInfo){
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push(element);
                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleUpdateNosearch = () => {
        let URL = SERVICE.getAvalGrid + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;

        api(URL)
            .then((data) => {
                
                let arrayTemp = [];
                if(data && data.data && data.data.paginationInfo){
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push(element);
                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    // const handleUpdateRoles = () => {

    //     api(SERVICE.getRoles)
    //         .then((data) => {
    //             let arrayTemp = [];
    //             for (let index = 0; index < data.data.data.length; index++) {
    //                 const element = data.data.data[index];
    //                 arrayTemp.push({
    //                     id: element.id,
    //                     identifier: element.identifier,
    //                     description: element.description
    //                 })
    //             }
    //             setRoles(arrayTemp);
    //         })
    //         .catch((err) => {

    //         })
    // }
    const handleGetGenders = () => {
        api(SERVICE.getGenders)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setGenders(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    useEffect(() => {
        handleGetGenders();
    }, [])
    useEffect(() => {
        if (genders.length > 0) {
            handleUpdate();
        }
    }, [page, perPage, genders])
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    return (
        <>
            <WindowLayout
                title="AVALES"
                route={["Inicio","Catálogos","Avales"]}
                actions={[()=>setMenuActual("homeMenu"),()=>setMenuActual("catalogMenu")]}
                icon={<FaUserFriends />}
            >
                <div className='paperContainer'>
                    <div className={styles.containerButtomTop}>
                        <button className='btn btn-sm btn-success' onClick={() => setShowModal(!showModal)}><FaPlus /></button>
                    </div>
                                        <div className="input-group flex-nowrap searchContainer" style={{ marginBottom: "10px", width: "min(500px, 100%)", maxWidth: "500px" }}>
                        <input type="text" className="form-control" placeholder="Búsqueda" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                        <button className='btn btn-primary' onClick={handleUpdate}><FaSearch /></button>
                    </div>
                    <div className="input-group flex-nowrap containerSearchPrev" style={{ display: textSearchPrev !== "" ? "flex" : "none" }}>
                        <div className="badgeSearch">Buscando por: <b>{textSearchPrev}</b> </div><div onClick={() => {
                            setTextSearch("");
                            setTextSearchPrev("");
                            handleUpdateNosearch();
                        }} className='divCloseSearch'><MdClose></MdClose></div>
                    </div>
                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={loadingTable}
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        responsive
                    />

                </div>
            </WindowLayout>
            <ModalAval
                show={showModal}
                setShow={setShowModal}
                roles={roles}
                dataEdit={userEdit}
                setDataEdit={setUserEdit}
                estados={estados}
                municipios={municipios}
                codigos={codigos}
                handleUpdate={handleUpdate}
                genders={genders}
            />
        </>
    );
} 